import { STOCK_RECEIPT_FIELD_LABELS } from '#/modules/imsMgmt/receipts/stockReceipt/schemas/stockReceiptSchema';

const PACKAGE_FIELD_LABELS = {
  locationId: STOCK_RECEIPT_FIELD_LABELS['lines.packages.locationId'] || '儲位',
  qty: STOCK_RECEIPT_FIELD_LABELS['lines.packages.qty'] || '數量',
  remark: '包裝備註',
};

const LINE_FIELD_LABELS = {
  mtrId: STOCK_RECEIPT_FIELD_LABELS['lines.mtrId'] || '物料',
  unitId: STOCK_RECEIPT_FIELD_LABELS['lines.unitId'] || '單位',
  unitPrice: STOCK_RECEIPT_FIELD_LABELS['lines.unitPrice'] || '單價',
  remark: '行備註',
  packages: '包裝',
};

/**
 * 組成物料顯示前綴：料號＋名稱；缺則 fallback。
 * index 僅作顯示序號，不作資料識別鍵。
 */
export function formatStockReceiptMaterialLabel(line, lineIndex) {
  const no = line?.mtrNo?.trim?.() || line?.mtrNo || '';
  const name = line?.mtrName?.trim?.() || line?.mtrName || '';
  if (no && name) {
    return `${no} ${name}`;
  }
  if (name) {
    return name;
  }
  if (no) {
    return no;
  }
  return `明細 #${Number(lineIndex) + 1}`;
}

/**
 * 解析入庫驗證錯誤 path →「物料 X・包裝 #N・欄位」標籤。
 * @param {string} path
 * @param {{ lines?: object[] }} [context]
 * @returns {string|undefined}
 */
export function resolveStockReceiptFieldLabel(path, context = {}) {
  if (!path) {
    return undefined;
  }

  const lines = context.lines ?? [];

  const packageFieldMatch = path.match(
    /^lines\.(\d+)\.packages\.(\d+)\.(\w+)$/,
  );
  if (packageFieldMatch) {
    const lineIndex = Number(packageFieldMatch[1]);
    const packageIndex = Number(packageFieldMatch[2]);
    const field = packageFieldMatch[3];
    const materialLabel = formatStockReceiptMaterialLabel(lines[lineIndex], lineIndex);
    const fieldLabel = PACKAGE_FIELD_LABELS[field] || field;
    return `${materialLabel}・包裝 #${packageIndex + 1}・${fieldLabel}`;
  }

  const packagesRootMatch = path.match(/^lines\.(\d+)\.packages$/);
  if (packagesRootMatch) {
    const lineIndex = Number(packagesRootMatch[1]);
    const materialLabel = formatStockReceiptMaterialLabel(lines[lineIndex], lineIndex);
    return `${materialLabel}・包裝`;
  }

  const lineFieldMatch = path.match(/^lines\.(\d+)\.(\w+)$/);
  if (lineFieldMatch) {
    const lineIndex = Number(lineFieldMatch[1]);
    const field = lineFieldMatch[2];
    const materialLabel = formatStockReceiptMaterialLabel(lines[lineIndex], lineIndex);
    const fieldLabel = LINE_FIELD_LABELS[field] || field;
    return `${materialLabel}・${fieldLabel}`;
  }

  if (path === 'lines') {
    return STOCK_RECEIPT_FIELD_LABELS.lines;
  }

  return undefined;
}
